/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Screen, Text, TableAdmin } from '../../../components';
import { Row, Col } from 'react-bootstrap';
import cooperativesService from '../../../services/cooperatives';
const { defaultStates, defaultAlertScreenOnClick } = require('../../../utils/defaults');

class CooperativesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cooperativesList: [],
      ...defaultStates(),
    };

    this.modalOnHide = this.modalOnHide.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.body = this.body.bind(this);
    this.footer = this.footer.bind(this);
    this.fillTable = this.fillTable.bind(this);
  }

  async componentDidMount() {
    await this.fillTable();
  }

  async fillTable(error = true) {
    this.setState({ loadingState: true });

    const response = await cooperativesService.admin.getList();
    if (response.ok && response.data) {
      const data = response.data.map((i) => {
        i.isActive = i.isActive ? 'Ativo' : 'Rascunho';
        return i;
      });

      this.setState({ cooperativesList: data });
    } else {
      if (error) {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  modalOnHide() {
    const { modalState } = this.state;
    modalState.toggle = false;
    this.setState(modalState);
    this.fillTable(false);
  }

  alertScreenOnClick() {
    defaultAlertScreenOnClick(this);
  }

  body() {
    const onCellClick = ({ id }) => this.props.history.push(`/gestao/cooperatives/${id}`);

    const columns = [
      { headerName: 'ID', field: 'id', hide: true, flex: 0.05 },
      { headerName: 'Nome', field: 'name', flex: 0.4 },
      { headerName: 'Sigla', field: 'sigla', flex: 0.4 },
    ];

    return (
      <>
        <Row align={'center'}>
          <Col>
            <Text title text={'Cooperativa'} />
          </Col>
        </Row>
        <Row>
        <Col align="left">
          <Button
            underlinePlus
            text={'upload planilha cvs'}
            onClick={() => this.props.history.push('/gestao/csv')}
          />
        </Col>
        <Col align="right">
          <Button
            underlinePlus
            text={'adicionar'}
            onClick={() => this.props.history.push('/gestao/cooperatives/novo')}
            className="ml-auto"
          />
        </Col>
      </Row>
        <Row className="justify-content-center">
          <Col className="mt-3">
            <TableAdmin
              onCellClick={onCellClick}
              data={this.state.cooperativesList}
              columns={columns}
            />
          </Col>
        </Row>
      </>
    );
  }

  footer() {
    return (
      <>
        <Row align="center"></Row>
      </>
    );
  }

  render() {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        admin
        body={this.body}
        footer={this.footer}
        modalState={modalState}
        loadingState={loadingState}
        alertScreenState={alertScreenState}
      />
    );
  }
}

CooperativesList.propTypes = {
  //props
  match: PropTypes.object,
  history: PropTypes.object,
};

export default CooperativesList;
